import { render, staticRenderFns } from "./appSSO.vue?vue&type=template&id=53ac2eba&scoped=true&"
import script from "./appSSO.vue?vue&type=script&lang=js&"
export * from "./appSSO.vue?vue&type=script&lang=js&"
import style0 from "./appSSO.vue?vue&type=style&index=0&id=53ac2eba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ac2eba",
  null
  
)

export default component.exports